<app-banner [heading]="'LANGUAGE LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
	<section id="features" class="features">
      <div class="container">

        <div class="row feature-item">

		<div class="col-lg-6 pt-5 pt-lg-0" >
			
			<h1> COMING SOON..</h1>
          </div>

          
		</div>
      </div>
	</section><!-- End About Section -->
	
  </main>